import { render, staticRenderFns } from "./SignUpPageLanguage.vue?vue&type=template&id=377f2b17&"
import script from "./SignUpPageLanguage.vue?vue&type=script&lang=js&"
export * from "./SignUpPageLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports